import * as React from 'react';

export const Minus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 18 18" {...props}>
    <g fill="none" fillRule="evenodd">
      <rect width="100%" height="100%" fill="currentColor" rx="4" />
      <path fill="#fff" d="M12 8a1 1 0 0 1 .117 1.993L12 10H6a1 1 0 0 1-.117-1.993L6 8h6z" />
    </g>
  </svg>
);
